import { FC, useEffect, useState } from 'react';
import { Grid, Step, StepConnector, StepContent, StepLabel, Stepper, SvgIcon, SvgIconProps, Theme, Typography, createStyles, makeStyles, useMediaQuery, useTheme, withStyles } from '@material-ui/core';
import { Colors } from '../../helpers/theme';

interface LockTierStepperProps {
    lockAmount: number;
    setLockAndStakeAmount: (amount: number) => void
}

const ColoredTierConnector = withStyles({
    line: {
        height: 0,
        border: 0,
    },
})(StepConnector);

function ColoredTierIcon() {
    // For now we return an empty div, but we can use this to add icons later
    return (
    <>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop:"1rem",
      "& .MuiStep-horizontal": {
        padding: 0,
        justifyContent: 'space-between',
      },
      "& .MuiStepLabel-root": {
        display: 'contents',
      },
      '& .MuiPaper-root':{
        minWidth:"100%",
      }
    },
    button: {
      marginRight: theme.spacing(1),
    },
    label: {
        "& .MuiStepLabel-label": {
            fontSize:"12px",
            fontWeight: 700,
            lineHeight:"15.15px",
            color: Colors.darkSlate, 
            transition: 'font-size 0.5s ease',
            cursor: 'pointer',
            [theme.breakpoints.down("sm")]: {
                transition: 'font-size 0.2s ease',
            },
            "& .striked-amount": {
                color:'rgba(107, 130, 153, 0.7)',
                fontSize:"12px",
                lineHeight:"13.89px",
                fontWeight: 700,
                textDecoration: 'line-through',
               
            },
            "& .amount": {
                color:Colors.greenLight,
                fontSize:"12px",
                lineHeight:"13.89px",
                fontWeight: 700,
               
            },
            "& .bonus": {
                color:'rgba(107, 130, 153, 0.7)',
                fontSize:"11px",
                marginTop:"0.3rem",
                
            },
        },
        "& .MuiStepLabel-active": {

            fontSize: '1rem',
            [theme.breakpoints.down("sm")]: {
                fontSize: '14px'
            }
        },
    },
  }),
);

function stepperContent (amount: string, bonus: number, isActive: boolean = false) {
    return (
        <div style={{ width: 'max-content' }}>
            <span className='amount'>{amount}</span>
            <br/>
            <span className='bonus'>{bonus}% Bonus</span>
        </div>
    )
}

function getSteps() {
    return ['Planktons', 'Fishes', 'Dolphins', 'Sharks', 'Whales']
  }
  
function getStepContent(step: number, isActive: boolean) {
    switch (step) {
        case 0:
        return stepperContent('1,000', 0, isActive);
        case 1:
        return stepperContent("10,000", 5, isActive);
        case 2:
        return stepperContent( "30,000", 10, isActive);
        case 3:
        return stepperContent( "100,000", 15, isActive);
        case 4:
        return stepperContent( "200,000", 20, isActive);
        default:
        return 'Unknown step';
    }
}

const LockTierStepper: FC<LockTierStepperProps> = ({ lockAmount, setLockAndStakeAmount }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isActive = useMediaQuery(theme.breakpoints.down('sm'));
    const [activeStep, setActiveStep] = useState(-1);
    const steps = getSteps();
    
    useEffect(() => {
        if (lockAmount < 1000) {
            setActiveStep(-1);
        } else if (lockAmount < 10000) {
            setActiveStep(0);
        } else if (lockAmount < 30000) {
            setActiveStep(1);
        } else if (lockAmount < 100000) {
            setActiveStep(2);
        } else if (lockAmount < 200000) {
            setActiveStep(3);
        } else {
            setActiveStep(4);
        }
    }, [lockAmount]);

    const handleClick = (index: number) => {
        if (index === 0) setLockAndStakeAmount(1000)
        else if (index === 1) setLockAndStakeAmount(10000)
        else if (index === 2) setLockAndStakeAmount(30000)
        else if (index === 3) setLockAndStakeAmount(100000)
        else if (index === 4) setLockAndStakeAmount(200000)
        else return;
    }

    return (
        <Grid container className={classes.root}>
            <Stepper 
                activeStep={activeStep}
                connector={<ColoredTierConnector />}
                content='center'
            >
                {steps.map((label, index) => (
                    <Step key={label} onClick={() => handleClick(index)}>
                        <StepLabel 
                            StepIconComponent={ColoredTierIcon}
                            className={classes.label}
                        >     
                            <Grid item lg={2}>
                                {label}
                                { getStepContent(index, isActive) }
                            </Grid>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Grid>
    )
}

export default LockTierStepper;